<template>
  <div class="root">
    <button class="btn back-btn" @click="navigateBack">
      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.69945 0.366117C9.18761 -0.122039 9.97887 -0.122039 10.467 0.366117C10.9552 0.854272 10.9552 1.64554 10.467 2.13369L3.01748 9.58324L10.467 17.0328C10.9552 17.5209 10.9552 18.3122 10.467 18.8004C9.97887 19.2885 9.18761 19.2885 8.69945 18.8004L0.366117 10.467C-0.122039 9.97887 -0.122039 9.1876 0.366117 8.69945L8.69945 0.366117Z" fill="black"/>
      </svg>
    </button>

    <div v-if="loading">loading...</div>

    <div v-else-if="!coupon" class="text-center my-4">ไม่พบข้อมูลคูปอง</div>

    <div v-else class="coupon-container">
      <img v-lazy="coupon.posterUrl" alt="coupon">
      <div class="coupon-header">
        <div class="coupon-title">{{ coupon.title }}</div>
        <div class="d-flex align-items-center">
          <img :src="require('@/assets/icon/BevFamilyPoint.png')" alt="bev point" width="34" height="34" class="mr-1" />
          <span class="coupon-point">{{ $toLocal(coupon.redeemPoint) }}</span>
          <span class="coupon-remaining-badge" v-if="coupon.couponRedeemRemaining != null">เหลือ {{ coupon.couponRedeemRemaining }} ชิ้น</span>
        </div>
        <!-- <div>
          <i class="icon-calendar mr-1"></i>
          <span class="coupon-expire-date">แลกได้ถึง {{ $getDate(coupon.couponEndDate) }}</span>
        </div> -->
      </div>

      <div class="divider"></div>

      <div class="coupon-details" v-if="coupon.detail">
        <b>รายละเอียด</b>
        <div>{{ coupon.detail }}</div>
      </div>
    </div>

    <div class="btn-container">
      <button class="btn btn-primary w-100" @click="redeemCoupon" :disabled="loading">แลกคะแนน</button>
    </div>

    <b-modal
      id="redeem_success_modal"
      hide-footer
      centered
      @shown="onRedeemModalShown"
      @hidden="resetSlide"
    >
      <template v-slot:modal-header-close>
        <i class="close-modal">
          <svg
            viewPort="0 0 18 18"
            width="18px"
            height="18px"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1"
              y1="17"
              x2="17"
              y2="1"
              stroke="black"
              stroke-width="2"
              vector-effect="non-scaling-stroke"
            />
            <line
              x1="1"
              y1="1"
              x2="17"
              y2="17"
              stroke="black"
              stroke-width="2"
              vector-effect="non-scaling-stroke"
            />
          </svg>
        </i>
      </template>

      <div class="redeem-modal-content">
        <div class="redeem-modal-title">ยืนยันการแลกคะแนน</div>
        <p class="redeem-modal-desc">
          ยืนยันแลกรับ "{{ coupon && coupon.title }}" ใช้ {{ coupon && $toLocal(coupon.redeemPoint) }} คะแนน สำหรับใช้ใน BevFamily เท่านั้น
        </p>
      </div>
      <div>
        <div ref="slideTrack" class="slide-confirm-track" :class="{ completed: redeemSubmitting }">
          <div class="slide-confirm-fill" :class="{ dragging: isSliding }" :style="{ width: `${thumbLeft + thumbSize + 5}px` }"></div>
          <div class="slide-confirm-label">
            {{ redeemSubmitting ? "กำลังยืนยัน..." : "เลื่อนเพื่อยืนยัน" }}
          </div>
          <button
            ref="slideThumb"
            type="button"
            class="slide-confirm-thumb"
            :class="{ dragging: isSliding }"
            :style="{ transform: `translate(${thumbLeft}px, -50%)` }"
            :disabled="redeemSubmitting"
            @pointerdown.prevent="onSlideStart"
          >
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.8936 14.7437C25.3048 14.3325 25.3048 13.6675 24.8936 13.2606L17.5436 5.90622C17.1323 5.49497 16.4673 5.49497 16.0604 5.90622C15.6536 6.31747 15.6492 6.98247 16.0604 7.38934L21.6167 12.9456H3.8498C3.26793 12.9456 2.7998 13.4137 2.7998 13.9956C2.7998 14.5775 3.26793 15.0456 3.8498 15.0456H21.6167L16.0604 20.6018C15.6492 21.0131 15.6492 21.6781 16.0604 22.085C16.4717 22.4918 17.1367 22.4962 17.5436 22.085L24.8936 14.7437Z" fill="white"/>
            </svg>
          </button>
        </div>
      </div>
    </b-modal>

    <transition name="list">
      <PinCodeInput
        v-if="enterPincode"
        v-on:already-pin="alreadyPin"
        v-on:close="closePinInput"
        :title="'กรุณาใส่ PIN'"
        :reset_pin="'ลืม PIN ?'"
        v-on:reset-pin="resetPin"
        :pin_length="6"
      />
    </transition>
  </div>
</template>

<script>
import PinCodeInput from "@/components/pinCodeInput";

export default {
  name: "couponDetails",
  components: { PinCodeInput },
  data() {
    return {
      loading: false,
      coupon: null,
      isSliding: false,
      redeemSubmitting: false,
      enterPincode: false,
      thumbLeft: 0,
      sliderMax: 0,
      trackLeft: 0,
      thumbSize: 48,
      horizontalPadding: 4,
    };
  },
  computed: {
    rewardsData() {
      return this.$store.state.rewards.data || [];
    },
  },
  methods: {
    async fetchRewards() {
      return await fetch(process.env.VUE_APP_API_URL + "/rewards", {
        method: "GET",
        headers: { Authorization: `Bearer ${this.$JWT}` },
      });
    },
    async init() {
      this.loading = true;
      const code = this.$route.params.code;

      // fetch ถ้า store ว่าง
      if (this.rewardsData.length === 0) {
        try {
          const res = await this.fetchRewards();
          if (res.status === 200) {
            const body = await res.json();
            this.$store.commit("SET_REWARDS", body);
          }
        } catch (e) {
          console.log(e);
        }
      }

      const found = this.rewardsData.find((rw) => String(rw.id) === String(code));
      if (found) {
        this.coupon = found;
      }
      this.loading = false;
    },
    redeemCoupon() {
      this.$bvModal.show("redeem_success_modal");
    },
    onRedeemModalShown() {
      this.$nextTick(() => {
        const track = this.$refs.slideTrack;
        const thumb = this.$refs.slideThumb;
        if (!track || !thumb) return;

        const trackRect = track.getBoundingClientRect();
        this.thumbSize = thumb.clientWidth || 48;
        this.trackLeft = trackRect.left + 2;
        this.sliderMax = Math.max(track.clientWidth - this.thumbSize - this.horizontalPadding, 0);
        this.thumbLeft = 0;
      });
    },
    onSlideStart(e) {
      if (this.redeemSubmitting) return;

      const track = this.$refs.slideTrack;
      if (!track) return;

      const trackRect = track.getBoundingClientRect();
      this.trackLeft = trackRect.left + 2;
      this.isSliding = true;
      document.body.style.userSelect = "none";

      window.addEventListener("pointermove", this.onSlideMove);
      window.addEventListener("pointerup", this.onSlideEnd);
      window.addEventListener("pointercancel", this.onSlideEnd);

      this.onSlideMove(e);
    },
    onSlideMove(e) {
      if (!this.isSliding) return;
      const next = e.clientX - this.trackLeft - this.thumbSize / 2;
      this.thumbLeft = Math.max(0, Math.min(next, this.sliderMax));
    },
    async onSlideEnd() {
      if (!this.isSliding) return;

      this.isSliding = false;
      document.body.style.userSelect = "";
      window.removeEventListener("pointermove", this.onSlideMove);
      window.removeEventListener("pointerup", this.onSlideEnd);
      window.removeEventListener("pointercancel", this.onSlideEnd);

      const passed = this.sliderMax > 0 && this.thumbLeft >= this.sliderMax * 0.92;
      if (!passed) {
        this.thumbLeft = 0;
        return;
      }

      this.$bvModal.hide("redeem_success_modal");
      this.enterPincode = true;
    },
    async fetchRedeem(pincode) {
      const body = {
        rewardId: this.coupon.id,
        quantity: 1,
        pincode: pincode,
      };
      if (this.coupon.rewardFlowId != null) {
        body.rewardFlowId = this.coupon.rewardFlowId;
      }
      return await fetch(process.env.VUE_APP_API_URL + "/rewards/redeem", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$JWT}`,
        },
        body: JSON.stringify(body),
      });
    },
    alreadyPin(pin) {
      this.enterPincode = false;
      this.confirmRedeem(pin);
    },
    closePinInput(val) {
      if (val) {
        this.enterPincode = false;
        this.thumbLeft = 0;
      }
    },
    resetPin() {
      this.$router.replace({
        name: "otp",
        params: {
          route_back: this.$route,
          route_after_success: {
            name: "set-pin",
            params: { route_after_success: this.$route },
          },
        },
      });
    },
    async confirmRedeem(pincode) {
      this.redeemSubmitting = true;
      this.thumbLeft = this.sliderMax;
      try {
        const res = await this.fetchRedeem(pincode);
        const body = await res.json();
        this.redeemSubmitting = false;
        switch (res.status) {
          case 200:
            this.Swal.fire("แลกคูปองสำเร็จ", "", "success").then(() => {
              this.$router.replace("/coupons");
            });
            break;
          case 422:
          case 403:
            if (body?.message === "INVALID_PINCODE") {
              this.Swal.fire({
                title: "PIN ไม่ถูกต้อง",
                text: "กรุณาลองใหม่ หรือติดต่อเจ้าหน้าที่",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Reset Pin",
                cancelButtonText: "กลับ",
              }).then((result) => {
                if (result.value) this.resetPin();
              });
            } else {
              this.Swal.fire("ไม่สามารถแลกได้", body?.message || "", "warning");
            }
            break;
          default:
            this.Swal.fire("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
        }
      } catch (e) {
        console.log(e);
        this.redeemSubmitting = false;
        this.Swal.fire("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
      }
    },
    resetSlide() {
      this.isSliding = false;
      this.redeemSubmitting = false;
      this.thumbLeft = 0;
      this.trackLeft = 0;
      document.body.style.userSelect = "";
      window.removeEventListener("pointermove", this.onSlideMove);
      window.removeEventListener("pointerup", this.onSlideEnd);
      window.removeEventListener("pointercancel", this.onSlideEnd);
    },
    navigateBack() {
      this.$router.push("/rewards");
    },
  },
  beforeDestroy() {
    this.resetSlide();
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.root {
  padding: 16px;
  padding-bottom: 128px;
  background: white;
}
.back-btn {
  margin-bottom: 16px;
}
.coupon-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.coupon-container img {
  object-fit: contain;
}
.coupon-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.coupon-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.coupon-point {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  color: #005224;
  margin-right: 24px;
}
.coupon-remaining-badge {
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  color: white;
  background-color: #54d78d;
  border-radius: 4px;
  padding: 6px 4px;
}
.coupon-expire-date {
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  color: #989898;
}
.divider {
  border-top: 2px solid #efefef;
}
.coupon-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.btn-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 16px;
  background-color: white;
  box-shadow: 2px -3px 10px rgba(0, 0, 0, 0.15);
}
.close-modal {
  position: absolute;
  top: 0;
  right: 8px;
}
.redeem-modal-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
}
.redeem-modal-title {
  font-weight: bold;
  font-size: 24px;
  line-height: 1.5;
  text-align: center;
}
.redeem-modal-desc {
  text-align: center;
  font-size: 16px;
  line-height: 1.2;
}
.slide-confirm-track {
  position: relative;
  height: 52px;
  border-radius: 8px;
  overflow: hidden;
  background: #e6f9ee;
}
.slide-confirm-track.completed {
  background: #d6f5e4;
}
.slide-confirm-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: #54d78d;
  transition: width 0.14s ease;
  border-radius: 8px;
}
.slide-confirm-fill.dragging {
  transition: none;
}
.slide-confirm-label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: #006B2F;
  pointer-events: none;
}
.slide-confirm-thumb {
  position: absolute;
  top: 50%;
  left: 2px;
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 8px;
  background: #005224;
  color: #fff;
  z-index: 2;
  cursor: grab;
  touch-action: none;
  transition: transform 0.14s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slide-confirm-thumb.dragging {
  transition: none;
}
.slide-confirm-thumb:active {
  cursor: grabbing;
}
</style>
